var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 34.5,
    stroke: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5566 42.4431L42.4431 27.5566",
    stroke: "#21A6E9",
    strokeWidth: 2.48108,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3477 27.5566H42.4429V39.6519",
    stroke: "#21A6E9",
    strokeWidth: 2.48108,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem8);
export default __webpack_public_path__ + "static/media/item8.0ecf043d879b160ba0e58784e1f67863.svg";
export { ForwardRef as ReactComponent };